/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Needed for quick add */
function serialize(form) {
  var resultArray = new URLSearchParams(Array.from(new FormData(form))).toString().split("&");
  var result = {};
  resultArray.forEach(function (item) {
    var pair = item.split("=");
    result[pair[0]] = pair[1];
  });
  return result;
}

/* Quick add */
document.querySelectorAll(".quickAddForm").forEach(function (formElement) {
  formElement.addEventListener("submit", function (event) {
    try {
      event.preventDefault();
      var serialized = serialize(formElement);

      var addToCartButton = formElement.querySelector(".ProductForm__AddToCart"); // First, we switch the status of the button
      addToCartButton.setAttribute("disabled", "disabled");
      document.dispatchEvent(new CustomEvent("theme:loading:start")); // Then we add the product in Ajax
      fetch("".concat(window.routes.cartAddUrl, ".js"), {
        body: JSON.stringify(serialize(formElement)),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
        },
      }).then(function (response) {
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
        var quantityElement = formElement.querySelector('[name="quantity"]');

        if (response.ok) {
          addToCartButton.removeAttribute("disabled"); // We simply trigger an event so the mini-cart can re-render
          document.documentElement.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                quantity: serialized.quantity,
                variant: serialized.id,
              },
            })
          );
        } else {
          response.json().then(function (content) {
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "ProductForm__Error Alert Alert--error";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton.insertAdjacentElement("afterend", errorMessageElement);
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
          });
        }
      });
    } catch (e) {
      console.error("QuickAdd Error", e.message);
    }
  });
});

/* Yotpo translation hack */
setTimeout(function() {
  if(document.querySelectorAll(".yotpo-icon-button-text")) {
    document.querySelectorAll(".yotpo-icon-button-text").forEach(b => b.innerHTML = window.strings.yotpo.button_text);
    document.querySelectorAll(".write-first-review-button").forEach(b => b.innerHTML = window.strings.yotpo.first_review_button);
  }
}, 2000)

/* Code quiz translation hack */
setTimeout(function() {
  var locale = window.Shopify.locale || document.getElementsByTagName("HTML")[0].lang;
  window.quizTranslations = window.quizTranslations || [];
  if(window.quizTranslations.length && window.Shopify.locale === "fr") {
    console.log("Quiz hack", locale);
    window.quizTranslations.forEach(function(translation) {
      console.log("Quiz hack search", `a[href="${translation.en}"]`);
      var targets = document.querySelectorAll(`a[href="${translation.en}"]`);
      console.log("Quiz hack", targets.length)
      if(targets.length && translation.fr) {
        console.log("Quiz hack", translation.fr);
        targets.forEach(b => b.href = translation.fr);
      }
    })
  }
}, 2000)



 // Access the first element with the class 'pro_product'
var productSelect = document.getElementsByClassName('pro_product')[0];

if (productSelect) {
    productSelect.addEventListener('change', function() {
        var selectedValue = this.value;
        

        // Find all .variant_meta elements
        var variantMetaElements = document.querySelectorAll('.variant_meta');
        
        // Iterate through each .variant_meta element
        variantMetaElements.forEach(function(variantMeta) {
            var variantMetaId = variantMeta.getAttribute('data-id');
            
            // Check if the data-id matches the selected value
            if (variantMetaId === selectedValue) {
                // Add the display_display class
                variantMeta.classList.add('display_display');
                
            } else {
                // Optionally, remove the class if it does not match
                variantMeta.classList.remove('display_display');
               
            }
        });
    });
} else {
    console.log('No element with class pro_product found.');
}

// onload main code

window.addEventListener('load', function() {
 
  const targetId = '39623639859235';

  const variantMetaElements = document.querySelectorAll('.metafield .variant_meta');

  variantMetaElements.forEach(function(element) {
  
    const dataId = element.getAttribute('data-id');

    if (dataId === targetId) {
      
      element.classList.add('display_display');
      console.log('Match found and class added:', dataId);
    }
  });
});







